// extracted by mini-css-extract-plugin
export default {"container":"S1-z","list":"T1-z"};